/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AcceptTerms_viewer = {
    readonly id: string;
    readonly actualPersonId: string | null;
    readonly hasAcceptedTerms: boolean | null;
    readonly " $refType": "AcceptTerms_viewer";
};
export type AcceptTerms_viewer$data = AcceptTerms_viewer;
export type AcceptTerms_viewer$key = {
    readonly " $data"?: AcceptTerms_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AcceptTerms_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AcceptTerms_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAcceptedTerms",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '53f4c055e162301a976503c0edb69ee9';
export default node;
